import Fullscreen from "@/components/layout/fullscreen"
import { useEffect, useState } from "react"
import PayFrame from "./pay-frame"
import { PaymentLink, PaymentLinkType } from "@/api/payment-links"
import { User } from "@/api/users"
import PaymentForm from "./payment.form"
import HomeFrame from "./home.frame"

export default function PayPreviewScreen() {
  const [paymentLink, setPaymentLink] = useState<
    PaymentLink & { user: User }
  >()

  useEffect(() => {
    window.addEventListener("message", (e: MessageEvent) => {
      if (e.origin !== window.location.origin) return
      if (e.data.type === "payment-link") {
        setPaymentLink(e.data.data)
      }
    })
  }, [])

  if (!paymentLink) return null

  return (
    <Fullscreen>
      <PayFrame
        title={paymentLink.title}
        description={paymentLink.description}
        amount={
          paymentLink.type === PaymentLinkType.FIXED_AMOUNT
            ? paymentLink.amount
            : undefined
        }
        token={paymentLink.token}
        userName={paymentLink.user.firstName}
      >
        <HomeFrame shortId="test" token={paymentLink.token}>
          <PaymentForm
            shortId="test"
            collectData
            defaultValues={{
              amount: paymentLink.amount ? String(paymentLink.amount) : "",
              email: "",
              name: "",
              network: paymentLink.networks[0],
            }}
            networks={paymentLink.networks}
            token={paymentLink.token}
            amountOptions={
              paymentLink.type === PaymentLinkType.CUSTOM_AMOUNT
                ? {
                    min: paymentLink.minAmount,
                    max: paymentLink.maxAmount,
                    presetAmounts: paymentLink.presetAmounts,
                  }
                : undefined
            }
            onReady={() => {}}
            previewMode
          />
        </HomeFrame>
      </PayFrame>
    </Fullscreen>
  )
}
